const controller = function(component){
    var self = this;

    this.init = function(){
        component.percentage = {
            rules: {
                isValid: [
                    v => self.isValid(v) || self.messaging('survey > question > percentage > not_valid'),
                    v => self.withinRange(v,event) || self.messaging('survey > question > percentage > out_of_range')
                ]
            },
            tally: {}
        }        

        //Setup answers container
        self.clear();

        //Setup enable/disable switches
        var disabled = {};
        for(let g=0; g<component.question.config.groups.length; g++){
            var group = component.question.config.groups[g];

            disabled[group.id] = {};

            for(let i=0; i<group.inputs.length; i++){
                var input = group.inputs[i];
                disabled[group.id][input.id] = input.disabled ? true: false;
            }
        }
        component.disabled = disabled;      
        
        //Setup enable other
        self.clearOther();
    }

    this.messaging = function(key){
        var labels = component.$store.getters.library.labels;
        var language = component.$language();
        var defaultLanguage = 'en';
        var message = labels[key] ? (labels[key][language] ? labels[key][language] : labels[key][defaultLanguage]) : "[ERROR: "+key+" - does not exist]";

        return message;
    }

    this.setValue = function(group_id, valueArray){
        if( group_id && valueArray && typeof valueArray=='object' ){
            component.value[group_id] = valueArray;
        }else{
            console.error("setValue Error: ",{
                group_id: group_id,
                value: value
            })
        }
    }

    this.value_action = function(){
        return new Promise((resolve, reject)=>{          
            var values = component.value;
            for(let group_id in values){
                var answers = values[group_id];
                for(let input_id in answers){
                    var value = answers[input_id];
                    if(value!=null){
                        var test = parseInt(value,10);
                        if(isNaN(test)){
                            component.value[group_id][input_id]=null
                        }
                    }
                }
            }
            
            
            var enableOther = component.enableOther;
            var enableThese = {};
            for(let group_id in enableOther){
                enableThese[group_id] = {};
                var group = enableOther[group_id];
                for(let input_value in group){
                    enableThese[group_id][input_value] = false;
                    var config = component.get_config(group_id, input_value);
                                            
                    if( component.value[group_id][input_value]!=null && (config.input.other===true) ){
                        enableThese[group_id][input_value] =  true;
                    }
                }
            }
            component.enableOther = enableThese;

            var other = component.other;
            for(let group_id in enableThese){
                var group = enableThese[group_id];
                for(let input_value in group){
                    var enabled = enableThese[group_id][input_value];
                                            
                    if(enabled===false){
                        other[group_id][input_value] = null;
                    }
                }
            }
            
            component.percentage.tally = self.tally();

            resolve();
        })
    }

    this.clear = function(group_id, value){
        if(group_id && value){
            component.value[group_id][value] = null;
            self.clearOther(group_id, value);
        }else{
            var value = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                value[group.id] = {};

                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    value[group.id][input.id] = null;
                }
            }
            component.value = value;
            self.clearOther();
        }
        
    }

    this.setDisable = function(state, group_id, input_id){
        var config = component.get_config(group_id, input_id);
        var value = config.input.value;
        if(state===true){
            self.clear(group_id, value);
        }
        component.disabled[group_id][input_id] = state;
    }

    this.clearOther = function(group_id, value){
        if(group_id && value){
            component.other[group_id][value] = null;
            component.enableOther[group_id][value] = false;
        }else{
            //Setup 'other' fields
            var other = {}
            var enableOther = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                other[group.id] = {};
                enableOther[group.id] = {};
                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    enableOther[group.id][input.id] = false;
                    other[group.id][input.id] = null;
                }
            }
            component.other = other;
            component.enableOther = enableOther;
        }
    }

    this.isValid = function(v){
        return (v>=0 && v<=100);
    }

    this.withinRange = function(v,event){
        var result = true;
        
        if( event && (event.type=='input') ){
            var row = event ? event.target.dataset.row : null;
            var column = event ? event.target.dataset.column : null;
            var enforce_100 = event ? event.target.dataset['enforce-100'] : null;
            if(row && column && enforce_100){
                var total = component.percentage.tally[column];
                result = total<=100;
            }
        }


        return result;
    }


    this.tally = function(){
        var tally = {};

        for(let group_id in component.value){
            var answers = component.value[group_id];

            for(let input_id in answers){
                if(typeof tally[input_id]=='undefined'){
                    tally[input_id] = 0;
                }
                var percentage = answers[input_id] ? parseInt(answers[input_id]) : 0;
                tally[input_id] += percentage;
            }

        }        

        return tally;
    }

    this.validate = function(){
        var values = component.value;
        var enableOther = component.enableOther;
        var other = component.other;

        //If input itself is valid;
        var valid = true;
        for(let group_id in values){
            var group = values[group_id];

            for(let input_id in group){
                var value = group[input_id];
                var inRange = value!=null ? (value>=0 && value<=100) : true;
                var satisfy_other = enableOther[group_id][input_id]===true ? other[group_id][input_id].length>0 : true;
                valid =  inRange &&  satisfy_other

                if(!valid){
                    break;
                }
            }

            if(!valid){
                break;
            }            
        }

        //If tally is valid;
        var tally = this.tally();
        for(let column in tally){
            var value = tally[column];

            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
                if(group.id == column){
                    break;
                }
            }

            for(let i=0; i<group.inputs.length; i++){
                var input = group.inputs[i];
                if(input.id == column){
                    break;
                }
            }

            var enforce_100 = input.type_config ? input.type_config[component.question.config.type].enforce_100 : true;
            
            if( (value!=100 && enforce_100) ){
                valid = false;
            }
        }

        //If allow nulls;
        var noNulls = true;
        if(component.question.config.required){
            var answers = component.question.value;
            for(let group_id in answers){
                for(let g=0; g<component.question.config.groups.length; g++){
                    var group = component.question.config.groups[g];
                    if(group.id == group_id){
                        break;
                    }
                }                
                var group_answers = answers[group_id];

                for(let input_id in group_answers){
                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        if(input.id == input_id){
                            break;
                        }
                    }
                    var enforce_100 = input.type_config ? input.type_config[component.question.config.type].enforce_100 : true;

                    var value = group_answers[input_id];
                    if(value===null && !enforce_100){
                        noNulls = false;
                        break;
                    }
                }
            }
        }
        
        return valid && noNulls===true;
    }

    this.init();    
}

export default controller;